module.exports = __webpack_public_path__ + "fonts/icomoon.5b34dea.woff";